module.exports = function(app) {
    app.factory('dataManager', ['$q', 'services','sessionData','storage','spendingAccountsService','$q',
        function($q, services,sessionData,storage,spendingAccountsService,$q) {

            var
                getAccountTypes,getCompleteAccountInfo;

            getAccountTypes=function () {
                return storage.get("accountTypes") || [];
            }

            getCompleteAccountInfo = function(accountsDataResponse){
                var deferred = $q.defer();
                var completeAccountWithClaimInfo={"tempCompleteData":"","claimAmountData":""};
                //   var completionDeferred =$q.defer();
                var clientNumberList = spendingAccountsService.spendingAccountClients(sessionData.memberInfo);
                console.log("clientNumberList"+JSON.stringify(clientNumberList));
                var tempElectionArray = {};
                var tempCompleteData = [];
                accountsDataResponse.forEach(function(accountsData){
                    var glanceAccountsData= accountsData.glance;
                    var clientAccountList = glanceAccountsData.accountList.accountInfo || [];
                    var clientNumber = glanceAccountsData.groupCode;
                    var umi = glanceAccountsData.participantCode;
                    for ( var y in clientAccountList ) {
                        var accountSummaryData = clientAccountList[y];

                        // Add each election to temporary list
                        for (var z in accountSummaryData.electionList.electionDetails) {
                            var election = accountSummaryData.electionList.electionDetails[z];
                            tempElectionArray[election.id]=election;
                        }
                        //  accountSummaryData.electionList=[];

                    }


                    var accountInfoPromises = spendingAccountsService._accountInfoPromises(clientAccountList,clientNumber);
                    $q.all(accountInfoPromises).then(function(detailData){
                        for ( var y in clientAccountList ) {
                            var tempAccountInfo = angular.copy(clientAccountList[y]);

                            //now match to the detail data and build/mixin in
                            for ( var z in detailData ) {
                                var detailClientNumber = detailData[z].data.repAccountInfoReply.payload.repAccountInfoData.groupCode;
                                var detailUmi = detailData[z].data.repAccountInfoReply.payload.repAccountInfoData.participantCode;
                                var detailAccountInfo = detailData[z].data.repAccountInfoReply.payload.repAccountInfoData.accountList[0];

                                // Match the election details and mixin the enrollmentStatus
                                if (detailAccountInfo && detailAccountInfo.electionList && detailAccountInfo.electionList.length > 0) {
                                    for (var i = 0; i < detailAccountInfo.electionList.length;i++) {
                                        var detailElection = detailAccountInfo.electionList[i];
                                        if(tempElectionArray && tempElectionArray[detailElection.electionID]){
                                            var tempElection = tempElectionArray[detailElection.electionID];
                                            if((!detailElection.runOutEndDate ||
                                                ((new Date() - new Date(detailElection.runOutEndDate)) / 86400000) <= 365)) {
                                                detailElection = angular.extend(detailElection, {enrollmentStatus: tempElection.enrollmentStatus});
                                                //detailElection.enrollmentStatus = tempElection.enrollmentStatus;
                                            } /*else {
                                             detailAccountInfo.electionList.splice(i, 1);
                                             detailAccountInfo.electionListCount--;
                                             }*/
                                        }
                                        /* for (var h in tempElectionArray) {
                                         var tempElection = tempElectionArray[h];

                                         if (tempElection.id == detailElection.electionID) {
                                         if((!detailElection.runOutEndDate ||
                                         ((new Date() - new Date(detailElection.runOutEndDate)) / 86400000) <= 365)) {
                                         angular.extend(detailElection, {enrollmentStatus: tempElection.enrollmentStatus});

                                         } else {
                                         detailAccountInfo.electionList.splice(i, 1);
                                         detailAccountInfo.electionListCount--;
                                         }
                                         break;
                                         }
                                         }*/

                                    }


                                    if (clientNumber == detailClientNumber && tempAccountInfo.accountType == detailAccountInfo.accountTypeCode && detailAccountInfo.electionListCount > 0) {
                                        var accountCompleteInfo = angular.extend(tempAccountInfo, detailAccountInfo,{groupCode: clientNumber, participantCode: umi});
                                        tempCompleteData.push(accountCompleteInfo);
                                        break;
                                    }
                                }
                            }
                        };

                        // claim amount data to display info

                        var claimAmountData= accountsData.amount.accountList.account;
                        completeAccountWithClaimInfo.tempCompleteData = tempCompleteData;
                        completeAccountWithClaimInfo.claimAmountData = claimAmountData;
                        deferred.resolve(completeAccountWithClaimInfo);


                    });
                });

                return deferred.promise;

            };



            return {
                getAccountTypes: getAccountTypes,
                getCompleteAccountInfo:getCompleteAccountInfo

            };
        }
    ]);
};